/**
 * Cart Custom Fee Factory - 购物车定制费工厂
 * 工艺处理器工厂和配置管理
 * 
 * 依赖文件：
 * - cart-custom-fee-base-processor.js
 * - cart-custom-fee-embroidery-processor.js  
 * - cart-custom-fee-dtf-processor.js
 * - cart-custom-fee-pvc-processor.js
 */

// 工艺处理器工厂
class CraftProcessorFactory {
  static processors = {
    'EMBROIDERY': () => new EmbroideryProcessor(),
    'DTF_TRANSFER_PRINT': () => new DTFProcessor(),
    'PVC_PATCH': () => new PVCProcessor()
  };
  
  static getProcessor(processType) {
    const processorFactory = this.processors[processType];
    if (!processorFactory) {
      throw new Error(`Unknown process type: ${processType}`);
    }
    return processorFactory();
  }
  
  static getAllProcessTypes() {
    return Object.keys(this.processors);
  }
  
  static registerProcessor(processType, processorFactory) {
    this.processors[processType] = processorFactory;
  }
}

// Setup Fee 配置
const SETUP_FEE_CONFIG = {
  variantId: 42667598807107,
  productId: 7514504560707,
  requiredForRange: [1, 4],
  applicableProcesses: ['EMBROIDERY', 'DTF_TRANSFER_PRINT', 'PVC_PATCH']
};

// Plate Fee 配置（PVC工艺专用）
const PLATE_FEE_CONFIG = {
  variantId: 42667609358403,
  productId: 7514512752707,
  requiredForRange: [1, 24],
  applicableProcesses: ['PVC_PATCH']
};

// 将工厂和配置暴露到全局作用域
window.CraftProcessorFactory = CraftProcessorFactory;
window.SETUP_FEE_CONFIG = SETUP_FEE_CONFIG;
window.PLATE_FEE_CONFIG = PLATE_FEE_CONFIG;